"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getPosSrollParent = getPosSrollParent;
function getScrollParent(target) {
  var node = target && target.parentNode;
  if (!node) return target;
  while (node.parentNode && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || getComputedStyle(node).overflow === 'visible')) {
    node = node.parentNode;
  }
  return node;
}

/**
 * 获取target节点的pos轴上的scrollParent
 * @param {*} target
 * @param {string} pos 轴方向：x或y
 * @returns
 */
function getPosSrollParent(target) {
  var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'x';
  var node = target;
  if (!node) return target;
  if (pos && pos.toLowerCase && pos.toLowerCase() === 'x') {
    while (node.parentNode && (node.scrollWidth === node.clientWidth || getComputedStyle(node).overflowX === 'visible')) {
      node = node.parentNode;
    }
    return node;
  }
  if (pos && pos.toLowerCase && pos.toLowerCase() === 'y') {
    while (node.parentNode && (node.scrollHeight === node.clientHeight || getComputedStyle(node).overflowY === 'visible')) {
      node = node.parentNode;
    }
    return node;
  }

  // pos不合法时返回简单版scrollParent
  return getScrollParent(target);
}
var _default = exports.default = getScrollParent;